module.exports = new __parcel__URL__("alerts-task-four-illustration.e6d37245.png").toString();